import React from 'react';
import FinnitFooterLogo from '@assets/footer_logo.svg';
const FooterLogo = () => {
    const footerLogo = React.createElement(FinnitFooterLogo, null);
    return (React.createElement(React.Fragment, null, footerLogo));
};
export default FooterLogo;
